export default "__VITE_ASSET__JYsjUQt___"